// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3e0UV","header":"PatientQuestionnaire_header__tcyQX","info":"PatientQuestionnaire_info__32qcV"};